<!--
@Author: Calvin Green <calvin>
@Date:   2021-12-22T11:46:53+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-08-29T10:34:02+02:00
@Copyright: Diversitude 2021
-->

<template>
    <div v-if="hasMounted">
        <div v-if="type == null && canShowHeader" class="document__head">
                <div>
                    <!-- //* ------------------------------ -->
                    <table style="width: 100%;">
                        <tr>
                            <td colspan="2" style="width: 50%;">
                                <img :src="header_details.company_logo" alt="Company Logo" height="100"/>
                            </td>
                            <td colspan="2" style="width: 50%; text-align: center;" >
                                <span style="font-size: 2rem;color: red;">
                                    {{this.header_details.doc_heading}}</span>
                            </td>
                        </tr>

                        <tr class="bold-text">
                            <td colspan="4">{{this.header_details.doc_name}}</td>
                        </tr>

                        <tr class="bold-text">
                            <td colspan="3" style="">{{this.header_details.doc_description}}</td>
                            <td colspan="1" style=""></td>
                        </tr>

                        <tr class="bold-text">
                            <td style="" >SOP No:</td>
                            <td style="" >{{this.header_details.sop_number}}</td>
                            <td style="" >Effective Date</td>
                            <td style="" >{{this.header_details.effective_date}}</td>
                        </tr>

                        <tr class="bold-text">
                            <td style="" >Revision No:</td>
                            <td style="" >{{this.header_details.revision_number}}</td>
                            <td style="" >Supersedes</td>
                            <td style="" >{{this.header_details.supersedes}}</td>
                        </tr>

                        <tr class="bold-text">
                            <td style="" >Revise By</td>
                            <td style="" >{{this.header_details.revise_by_date}}</td>
                        </tr>
                    </table>
                    <!-- //* ------------------------------ -->
                </div>
            </div>
        <div class="document-editor" style="margin-top: 15px;" v-show="type != null">
            <ckeditor v-model="content" :config="editorConfig" :read-only="isReadOnly" @ready="onEditorReady"></ckeditor>
        </div>
        <div class="document-editor" style="margin-top: 15px;" v-show="type == null">
            <div v-if="b64 == null" v-html="content"></div>
            <div v-else>
                <!-- <annotate-pdf :base64="b64"></annotate-pdf> -->
                <iframe :src="b64 + '#toolbar=0'" style="width: 100%; height: 80vh;"></iframe>
            </div>
        </div>
       <!-- <div>
            <b-button v-if="type != null" @click="sendDataToParent" style="float: right;" class="mt-2 me-auto" variant="primary">
                <i class="fas fa-save me-2"></i>
                <strong>
                    Apply Changes
                </strong>
            </b-button>
        </div> --> 
    </div>
</template>

<script>
/* eslint-disable */
import Swal from 'sweetalert2'
import { header_data } from './header.js'
import { sopAdminMethods } from '@/state/helpers'
//import DecoupledEditor from "@/plugin/ckeditor-custom/ckeditor.js"
import CKEditor from 'ckeditor4-vue';
//import _ from 'lodash'
//import handlePageBreaks from '@/plugin/pagebreakplugin'
export default {
    data:() => ({
        debug_size:'',
        pause_event: false,
        doc_heading: 'Frogs',
        header_table:'',
        editor: null,
        hasMounted: false,
        //isReadOnly: false,
        content:'<h1>Hello world</h1>',
        editorConfig: {
            contentsCss: '/css/ckcustom.css',
            height: '55vh',
            on: {
                instanceReady: function (event) {
                    let dataProcessor = event.editor.dataProcessor;
                    let htmlFilter = dataProcessor && dataProcessor.htmlFilter;

                    if (htmlFilter) {
                        htmlFilter.addRules({
                            elements: {
                                p: function (element) {
                                    let style = element.attributes.style;
                                    // Ensure style attribute exists before attempting to modify it
                                    if (style) {
                                        style = style.replace(/font-family:.*?;/g, 'font-family: \'Open Sans\',\'sans-serif\';');
                                        element.attributes.style = style;
                                    }
                                    return element;
                                },
                            },
                        });
                    }
                },
            },
            extraPlugins: 'dialogui,dialog,a11yhelp,about,basicstyles,bidi,blockquote,clipboard,button,tableresize,panelbutton,panel,floatpanel,colorbutton,colordialog,menu,contextmenu,dialogadvtab,div,elementspath,enterkey,entities,popup,filebrowser,find,fakeobjects,floatingspace,listblock,richcombo,font,format,forms,horizontalrule,htmlwriter,iframe,image,indent,indentblock,indentlist,justify,link,list,liststyle,magicline,maximize,newpage,pagebreak,pastefromword,pastetext,preview,removeformat,resize,save,menubutton,scayt,selectall,showblocks,showborders,smiley,sourcearea,specialchar,stylescombo,tab,table,tabletools,templates,toolbar,undo,wysiwygarea',
        }
    }),
    components: {
        ckeditor: CKEditor.component
    },
    props:{
        text:{
            required: false,
            default:function(){
                return '';
            }
        },
        readOnly:{
            default:function(){
                return false;
            }
        },
        type:{},
        revision:{},
        b64: {
            default: null,
        }
    },
    watch:{
        text(newValue){
            if( newValue != null){
                this.pause_event = true;
                this.$nextTick(()=>{
                    //this.editor.setData(newValue);
                    this.content = newValue;
                    //set document to read only if displaying full document
                    //this.isReadOnly = (this.type == null ? true : false);

                    this.$nextTick(()=>{
                        this.pause_event = false;
                    })
                })

            }
        }
    },
    computed:{
        canShowHeader() {
            if(this.revision == undefined){
                return false;
            }
            else{
                return true;
            }
        },
        header_details() {
            let data = {};
            if(this.revision){
                data = this.revision.header_config;
            }
            else{
                data = {
                    doc_heading: '',
                    doc_name: '',
                    doc_description: '',
                    sop_number: '',
                    revision_number: '',
                    revise_by_date: '',
                    effective_date: '',
                    supersedes: '',
                    company_logo: '',
                }
            }
            return data;

        },
        header_html() {
            return `<table style="width: 100%;">
            <tr>
                <td colspan="2" style="width: 50%;">
                    <img :src="${this.header_details.company_logo}" alt="Company Logo" height="100"/>
                </td>
                <td colspan="2" style="width: 50%; text-align: center;" >
                    <span style="font-size: 2rem;color: red;">
                        ${this.header_details.doc_heading}</span>
                </td>
            </tr>

            <tr class="bold-text">
                <td colspan="4">${this.header_details.doc_name}</td>
            </tr>

            <tr class="bold-text">
                <td colspan="3" style="">${this.header_details.doc_description}</td>
                <td colspan="1" style="">Page x of x</td>
            </tr>

            <tr class="bold-text">
                <td style="" >SOP No:</td>
                <td style="" >${this.header_details.sop_number}</td>
                <td style="" >Effective Date</td>
                <td style="" >${this.header_details.effective_date}</td>
            </tr>

            <tr class="bold-text">
                <td style="" >Revision No:</td>
                <td style="" >${this.header_details.revision_number}</td>
                <td style="" >Supersedes</td>
                <td style="" >${this.header_details.supersedes}</td>
            </tr>

            <tr class="bold-text">
                <td style="" >Revise By</td>
                <td style="" >${this.header_details.revise_by_date}</td>
            </tr>
        </table>`
        },
        isReadOnly() {
            return this.type == null ? true : false;
        }
    },
    methods:{
        ...sopAdminMethods,
        insertMergeKey(text){
            if(this.type != null){
                this.editor.insertText(text);
            }
            else{
                Swal.fire({
                    toast: true,
                    position: 'top',
                    iconColor: 'lightBlue',
                    icon: 'info',
                    title:'Select a section to insert merge keys',
                    customClass: {     popup: 'info-toast' },
                    showConfirmButton: false,
                    timer: 3000, timerProgressBar: true
                });
            }
        },
        onEditorReady(editor) {
            this.editor = editor;
            let previousData = this.content;
            editor.on('blur', function() {
                const currentData = this.content;
                if (currentData !== previousData) {
                    this.renderPageBreaks();
                    previousData = currentData;
                }
            }.bind(this));
        },
        getEditorContentHeight(){
            let editor = this.editor;
            var doc = editor.document.$;
            var height = doc.body.scrollHeight;
            return parseInt(height);
        },
        initEditor(){
            //this.isReadOnly = (this.type == null ? true : false);
            this.content = this.text;
        },
        renderPageBreaks() {
            //let content = this.content;
            //let newData = handlePageBreaks(this.editor.getData());
            //this.content = newData;
            this.sendDataToParent(this.content);
            //console.log("newcontent", newcontent);
            //this.editor.setData(newcontent);
        },
        sendDataToParent(content){
            //let text = this.editor.getData();
            //let text = this.content;
            let height = this.getEditorContentHeight();
            console.log({text: content, height: height});
            this.$emit('updatedSection', {text: content, height: height});
        }
    },
    mounted(){
        //this.$eventHub.$on('forceSaveSection', this.sopAdminMethods)
        window.inst = this;

        //this.content = this.text;
        this.hasMounted = true;
        this.$nextTick(()=>{
            this.initEditor();
        });

        this.header_table = header_data;

        this.$eventHub.$on('insertMergeKey', this.insertMergeKey);
    },
    beforeDestroy(){
        window.inst = null;
        //this.clearSopStore();
        this.$eventHub.$off('insertMergeKey');
    }
}
</script>
<style lang="scss">
@for $i from 1 through 100 {
  ol[start="#{$i}"] {
    counter-reset: lis $i !important;
  }
}
</style>
<style scoped>
::v-deep ol {
    list-style-type: none !important;
}

::v-deep li ol {
  counter-reset: lis !important;
}

::v-deep li {
    counter-increment: lis !important;
}

::v-deep li::before {
    content: counters(lis, ".") ". " !important;
}

::v-deep li li::before {
    content: counters(lis, ".") " " !important;
}

/* header stuff */
table, th, td {
    border: 1px solid black;
  }
  #table.tableT{
    width: 100%;
}

</style>
